import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getUser, updateUserLevel, removeUserFromState } from "../../actions/users";
import UserLevel from "../../components/Loyalty/forms/UserLevel";
import LevelToUserForm from "../../components/Loyalty/forms/LevelToUserForm";

const LoyaltyToUser = ({ updateUserLevel, getUser, user, removeUserFromState }) => {
	const [currentUser, setCurrentUser] = useState("");

	useEffect(() => {
		setCurrentUser(user?.mail);
	}, [user, setCurrentUser]);

	return (
		<div>
			{currentUser ? (
				<LevelToUserForm updateUserLevel={updateUserLevel} user={user} cancelSubmit={removeUserFromState} />
			) : (
				<UserLevel getUser={getUser} />
			)}
		</div>
	);
};

const mapPropsToState = ({ user }) => ({ user });

export default connect(mapPropsToState, { getUser, updateUserLevel, removeUserFromState })(LoyaltyToUser);
